/**
 * 展示用电池温度 = 原始温度 + 偏差值。
 * 偏差值可为正或负；缺失/非法偏差时仅展示原始温度，避免出现 NaN。
 */
export function formatBatteryTempDisplay (batteryTemp, batteryTemperatureShowDeviation) {
  const raw = Number(batteryTemp)
  if (!Number.isFinite(raw)) {
    return '--'
  }
  if (
    batteryTemperatureShowDeviation == null ||
    batteryTemperatureShowDeviation === '' ||
    batteryTemperatureShowDeviation === '--'
  ) {
    return raw
  }
  const deviation = Number(batteryTemperatureShowDeviation)
  // 正负偏差均直接相加；Number.isFinite 会排除 NaN/Infinity
  if (!Number.isFinite(deviation)) {
    return raw
  }
  return raw + deviation
}
